import { IconAt, IconFile, IconInbox, IconSend } from '@tabler/icons-react';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys, useTranslation } from 'locales';
import { useLoadMailCount } from 'modules/Mails/hooks';
import { useMemo } from 'react';
import type { Menu } from '../types';

export function useBuildMailMenu(): Menu {
  const { t } = useTranslation();
  const company = useCompanyConfiguration();

  const { mailCount } = useLoadMailCount();

  return useMemo(() => {
    const showUpsell = !company?.package?.can_use_external_mails;

    const items = [
      {
        path: '/mails/inbox',
        label: t(i18nKeys.MAILS.INBOX),
        unreadCount: mailCount?.unprocessed,
        Icon: IconInbox,
        showUpsell,
      },
      {
        path: '/mails/outbox',
        label: t(i18nKeys.MAILS.SENT),
        Icon: IconSend,
        showUpsell,
      },
    ];

    items.push({
      path: '/mails/drafts',
      label: t(i18nKeys.MAILS.DRAFT),
      unreadCount: mailCount.draft,
      Icon: IconFile,
      showUpsell,
    });

    return {
      parent: null,
      label: t(i18nKeys.MAILS.NAV),
      Icon: IconAt,
      path: showUpsell ? '/mails' : '/mails/inbox',
      basePath: '/mails',
      showUpsell,
      items,
    };
  }, [t, company, mailCount]);
}
